
import { Question } from '../types';

export const taj101ExceptionsQuestions: Question[] = [
  {
    id: 'taj101',
    text: 'What is an exception to the rule that rāʾ sākinah preceded by a kasrah is pronounced with tarqīq?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When the kasrah is temporary (as in اِرْجِعِي)', isCorrect: true },
      { id: 'b', text: 'When the rāʾ sākinah is followed by a letter of istiʿlāʾ in the same word (as in فِرْقَة)', isCorrect: true },
      { id: 'c', text: 'When the rāʾ sākinah and the kasrah are in two different words (as in بِرِّ ارْحَمْهُمَا)', isCorrect: true },
      { id: 'd', text: 'When the rāʾ has a shadda', isCorrect: false }
    ],
    explanation: 'There are three exceptions to the rule that rāʾ sākinah preceded by a kasrah is pronounced with tarqīq: 1) When the kasrah is temporary, 2) When the rāʾ sākinah is followed by a letter of istiʿlāʾ in the same word, and 3) When the rāʾ sākinah and the kasrah are in two different words.',
    topic: 'taj101'
  },
  {
    id: 'taj102',
    text: 'In the word ارْتَضَى from Sūrah al-Anbiyāʾ, why is the rāʾ pronounced with tafkhīm despite being preceded by a kasrah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Because the kasrah is temporary', isCorrect: true },
      { id: 'b', text: 'Because the rāʾ has a shadda', isCorrect: false },
      { id: 'c', text: 'Because it is followed by a letter of istiʿlāʾ', isCorrect: false },
      { id: 'd', text: 'Because it comes at the beginning of the word', isCorrect: false }
    ],
    explanation: 'In ارْتَضَى, the rāʾ is pronounced with tafkhīm despite being preceded by a kasrah because the kasrah is temporary. You can verify this by joining it to what comes before it; the kasrah will no longer be pronounced, confirming its temporary nature.',
    topic: 'taj101'
  },
  {
    id: 'taj103',
    text: 'In the word مِرْصَاد (mirṣād), why is the rāʾ pronounced with tafkhīm despite being preceded by a kasrah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Because it is followed by a letter of istiʿlāʾ (ص) in the same word', isCorrect: true },
      { id: 'b', text: 'Because the kasrah is temporary', isCorrect: false },
      { id: 'c', text: 'Because the rāʾ and kasrah are in different words', isCorrect: false },
      { id: 'd', text: 'Because it is at the end of the word', isCorrect: false }
    ],
    explanation: 'In مِرْصَاد (mirṣād), the rāʾ is pronounced with tafkhīm despite being preceded by a kasrah because it is followed by a letter of istiʿlāʾ (ṣād) in the same word. This is one of the exceptions to the rule that rāʾ sākinah preceded by a kasrah is pronounced with tarqīq.',
    topic: 'taj101'
  },
  {
    id: 'taj104',
    text: 'When does idghām not take place despite the presence of its conditions?',
    type: 'single',
    options: [
      { id: 'a', text: 'When a nūn sākinah is followed by a yāʾ or wāw in the same word', isCorrect: true },
      { id: 'b', text: 'When a nūn sākinah is at the end of a word', isCorrect: false },
      { id: 'c', text: 'When a nūn sākinah is followed by a hamzah', isCorrect: false },
      { id: 'd', text: 'When a nūn sākinah has a tanwīn', isCorrect: false }
    ],
    explanation: 'Idghām does not take place when a nūn sākinah is followed by a yāʾ or wāw in the same word, despite these letters normally causing idghām. Examples include الدُّنْيَا (dunyā), بُنْيَان (bunyān), صِنْوَان (ṣinwān) and قِنْوَان (qinwān). In these cases, iṭh-hār is made instead.',
    topic: 'taj101'
  },
  {
    id: 'taj105',
    text: 'In the word أَنْهَار (anhār), which rule applies to the nūn sākinah?',
    type: 'single',
    options: [
      { id: 'a', text: 'Iṭh-hār', isCorrect: true },
      { id: 'b', text: 'Idghām', isCorrect: false },
      { id: 'c', text: 'Ikhfāʾ', isCorrect: false },
      { id: 'd', text: 'Iqlāb', isCorrect: false }
    ],
    explanation: 'In أَنْهَار (anhār), the nūn sākinah is followed by a hāʾ (ه), which is one of the throat letters. The rule of iṭh-hār applies to nūn sākinah when it is followed by any of the throat letters (ء, هـ, ع, ح, غ, خ).',
    topic: 'taj101'
  },
  {
    id: 'taj106',
    text: 'When does the lām in the name of Allah (الله) become pronounced with tafkhīm?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'When preceded by a fatḥah', isCorrect: true },
      { id: 'b', text: 'When preceded by a ḍammah', isCorrect: true },
      { id: 'c', text: 'When preceded by a kasrah', isCorrect: false },
      { id: 'd', text: 'When preceded by a sukūn', isCorrect: false }
    ],
    explanation: 'The lām in the name Allah (الله) is pronounced with tafkhīm when it is preceded by a fatḥah or a ḍammah. If it is preceded by a kasrah, it is pronounced with tarqīq.',
    topic: 'taj101'
  },
  {
    id: 'taj107',
    text: 'In the phrase بِسْمِ اللهِ (bismillāh), how is the lām in the word Allah pronounced?',
    type: 'single',
    options: [
      { id: 'a', text: 'With tarqīq (thin pronunciation)', isCorrect: true },
      { id: 'b', text: 'With tafkhīm (full pronunciation)', isCorrect: false },
      { id: 'c', text: 'With a madd', isCorrect: false },
      { id: 'd', text: 'With idghām', isCorrect: false }
    ],
    explanation: 'In بِسْمِ اللهِ (bismillāh), the lām in Allah is preceded by a kasrah. When the lām in Allah is preceded by a kasrah, it is pronounced with tarqīq (thin/empty-mouth pronunciation).',
    topic: 'taj101'
  },
  {
    id: 'taj108',
    text: 'What is the ruling on the basmalah at the beginning of Sūrah al-Tawbah?',
    type: 'single',
    options: [
      { id: 'a', text: 'The basmalah should not be recited', isCorrect: true },
      { id: 'b', text: 'The basmalah must be recited', isCorrect: false },
      { id: 'c', text: 'The basmalah is optional', isCorrect: false },
      { id: 'd', text: 'The basmalah is recommended but not obligatory', isCorrect: false }
    ],
    explanation: 'Sūrah al-Tawbah is the only sūrah in the Qur\'ān at the beginning of which the basmalah is not recited. This is mentioned in the section on istiʿādhah and basmalah.',
    topic: 'taj101'
  },
  {
    id: 'taj109',
    text: 'In the Qur\'ān, where should sakt be applied in the narration of Ḥafṣ?',
    type: 'multiple',
    options: [
      { id: 'a', text: 'بَلْ * رَانَ in Sūrah al-Muṭaffifīn', isCorrect: true },
      { id: 'b', text: 'مَنْ * رَاقٍ in Sūrah al-Qiyāmah', isCorrect: true },
      { id: 'c', text: 'مَرْقَدِنَا * هَٰذَا in Sūrah Yāsīn', isCorrect: true },
      { id: 'd', text: 'عِوَجًا * قَيِّمًا in Sūrah al-Kahf', isCorrect: true }
    ],
    explanation: 'In the narration of Ḥafṣ, sakt (stopping without breaking the breath) is applied in four places in the Qur\'ān: بَلْ * رَانَ in Sūrah al-Muṭaffifīn, مَنْ * رَاقٍ in Sūrah al-Qiyāmah, مَرْقَدِنَا * هَٰذَا in Sūrah Yāsīn, and عِوَجًا * قَيِّمًا in Sūrah al-Kahf.',
    topic: 'taj101'
  },
  {
    id: 'taj110',
    text: 'Which sūrah contains all the letters of the Arabic alphabet?',
    type: 'single',
    options: [
      { id: 'a', text: 'Sūrah al-Fātiḥah', isCorrect: false },
      { id: 'b', text: 'Sūrah al-Baqarah', isCorrect: false },
      { id: 'c', text: 'Sūrah ash-Shuʿarāʾ', isCorrect: true },
      { id: 'd', text: 'Sūrah al-Ikhlas', isCorrect: false }
    ],
    explanation: 'Sūrah ash-Shuʿarāʾ (The Poets) contains all the letters of the Arabic alphabet. This makes it useful for practicing the articulation of all Arabic letters.',
    topic: 'taj101'
  }
];
